export default class CardGame {
    constructor(props) {
        this.id = props.id || 0;
        this.cardMarketId = props.cardMarketId;
        this.name = props.name;
    }
}
